module.exports = __webpack_public_path__ + "img/cnLangBtn.98c63c23.png";